import { ActionFunction } from 'react-router-dom'

import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const removeSharedScoresAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const externalIds = formDataToArray(formData.get('scoreIds'))

  if (!externalIds.length) {
    return null
  }

  return http.action.post<RemoveSharedResponse>(ApiRoutes.apiSharedRemoveScoresPath(), {
    score_ids: externalIds,
  })
}

export default removeSharedScoresAction

export type RemoveSharedResponse = {
  failed: string[]
  scores: string[]
}
